import React from 'react';
import { useNavigate } from '@tanstack/react-router';

type DaaterLogoHomeLinkProps = {
  alt?: string;
  ariaLabel?: string;
  className?: string;
  imgClassName?: string;
};

export default function DaaterLogoHomeLink({
  alt = 'Daater',
  ariaLabel = 'Ir al inicio',
  className,
  imgClassName,
}: DaaterLogoHomeLinkProps) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => void navigate({ to: '/' })}
      className={className ?? 'inline-flex'}
      aria-label={ariaLabel}
    >
      <img src="/img/daater_logo.png" alt={alt} className={imgClassName} />
    </button>
  );
}
